
<div class="cmp-property-radio">
  <ws-radio-list
    v-if="options.length"
    v-model="model"
    :show-selected-only="!inEdit"
    selected-bolded
    without-delimiter
    :no-spacing-x="noSpacingX"
    :no-spacing-y="noSpacingY"
    small
    uid-prop="type"
    mode="item"
    :items="options"
  >
    <template v-slot="scope">
      <price-period
        class="float-right"
        individual
        :plain="!scope.isSelected"
        :price="inEdit ? scope.item.price : model.price"
        :prices="inEdit ? scope.item.prices : model.prices"
        :period="period"
        :hide-free="hideFree"
      />
      <span class="type-label">{{
        $t(path + '.' + scope.item.type + '.label')
      }}</span>
    </template>
    <template v-slot:info="scope">
      <small
        v-if="i18next.i18next.exists(path + '.' + scope.item.type + '.info')"
        class="q-mt-xs q-pl-sm inline-block"
        :class="inEdit ? 'q-ml-lg' : 'q-ml-xs'"
      >
        {{ $t(path + '.' + scope.item.type + '.info') }}
        <a v-if="link" class="ws-link" :href="link" target="_blank">{{
          $t(path + '.' + scope.item.type + '.link')
        }}</a>
      </small>
    </template>
  </ws-radio-list>
  <template v-else>
    <q-skeleton
      type="QRange"
      animation="fade"
      height="60px"
      class="q-mt-md"
    />
    <q-skeleton
      type="QRange"
      animation="fade"
      height="60px"
      class="q-mt-md"
    />
  </template>
</div>
